import get from 'transmute/get';
export const getKBRecommendationType = data => get('knowledgeBaseRecommendationType', data);